import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "../../_services/user/authentication/authentication.service";
// import { environment } from "@environment";
import { ConfigService } from "../../_services/config.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private environment: ConfigService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    
    if (
      this.isWfdssBackendCall(request.url) &&
      this.authenticationService.bearerToken
    ) {
      // console.debug("Attaching Bearer token")
      const headerVals = request.headers.append(
        "Authorization",
        `Bearer ${this.authenticationService.bearerToken}`
      );
      request = request.clone({ headers: headerVals });
    }

    return next.handle(request);
  }

  isWfdssBackendCall(requestUrl: string) {
    return requestUrl.startsWith(this.environment.baseBackendUrl) || requestUrl.startsWith("/");
  }
}
